module.exports = __webpack_public_path__ + "static/rto-national-4c92645c363f7722946f1bc6d69399e2.png";